// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const supabaseUrl = "https://cyllqmkqbdilicnbdxts.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN5bGxxbWtxYmRpbGljbmJkeHRzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM1MzAwODksImV4cCI6MjA0OTEwNjA4OX0.XIFuF99-LGaftuPzTfvFsunIzTYwzWjGlwUFkYe5xkA";

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase URL or API key');
}

export const supabase = createClient<Database>(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});